import { useState, useRef, useEffect } from "react";
import { Button } from "../../../../components/Button";
import styles from "./EditFavouriteButton.module.scss";

export function EditFavouritesButton({ children }) {
  const [showPopUp, setShowPopUp] = useState(false);
  const popUpRef = useRef(null);

  const handleClickOutside = (event) => {
    if (popUpRef.current && !popUpRef.current.contains(event.target)) {
      setShowPopUp(false);
    }
  };

  useEffect(() => {
    if (showPopUp) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPopUp]);

  return (
    <div ref={popUpRef} className={styles.editFavourites}>
      <Button clickHandler={() => setShowPopUp(!showPopUp)}>
        <div className={styles.more}>
          <div />
          <div />
          <div />
        </div>
      </Button>
      {Boolean(showPopUp) && children}
    </div>
  );
}
